export const CHANGE = "Change";
export const BLUR = "Blur";
export const BIG_DATA = "BigData";
export const BLUE_DATA = "BlueData";
export const HPE_CP = "HPECP";
export const NONGPU_ = "NonGPU";
export const GPU_ = "GPU";
export const STORAGE_ = "Storage";
export const GATEWAY_ = "Gateway";
export const CONTROLLER_ = "Controller";
export const MASTER_ = "Master";
export const GPU_NODE_STORAGE_DRIVE_QUANTITY = "GPUNodeStorageDriveQuantity";
export const GPU_NODE_STORAGE_DRIVE = "GPUStrDrivetype";
export const GPU_TENANT_DRIVE = "GPUTenantStoragedrive";
export const GPU_OSDRIVE = "GPUOSDrive";
export const NONGPU_NODE_STORAGE_DRIVE_QUANTITY = "NonGPUNodeStorageDriveQuantity";
export const NONGPU_NODE_STORAGE_DRIVE = "NonGPUStrDrivetype";
export const NONGPU_OSDRIVE = "NonGPUOSDrive";
export const NONGPU_TENANT_DRIVE = "NonGPUTenantStoragedrive";
export const STORAGE_HOST_ROLE_NAME = "Storage Host";
export const STORAGE_NODE_TYPE = "storageNodeType";
export const STORAGE_PROCESSOR_FAMILY = "storageProcFamilyType";
export const STORAGE_PROCESSOR_TYPE = "storageProcType";
export const STORAGE_MEMORY = "storageMemory";
export const STORAGE_NODE_DRIVE = "storageNodeDrive";
export const STORAGE_NODE_DRIVE_QTY = "storageNodeDriveQty";
export const STORAGE_OSDRIVE = "storageOSDrive";
export const STORAGE_TENANT_DRIVE = "storageTenantStoragedrive";
export const STORAGE_TENANT_DRIVE_QUANTITY = "storageTenantDriveQuantity";
export const STORAGE_NODE_COUNT = "storageNodeCount";
export const GATEWAY_NODE_STORAGE_DRIVE = "GatewayStrDrvtype";
export const GATEWAY_NODE_STORAGE_DRIVE_COUNT = "GatewayStrDrvCount";
export const GATEWAY_OSDRIVE = "GatewayOSDrive";
export const CONTROLLER_NODE_STORAGE_DRIVE = "ControllerStrDrvtype";
export const CONTROLLER_NODE_STORAGE_DRIVE_COUNT = "ControllerStrDrvCount";
export const CONTROLLER_TENANT_DRIVE = "TenantStrDrvtype";
export const CONTROLLER_TENANT_DRIVE_COUNT = "TenantStrDrvCount";
export const CONTROLLER_OSDRIVE = "ControllerOSDrive";
export const MASTER_NODE_STORAGE_DRIVE = "MasterStrDrvtype";
export const MASTER_NODE_STORAGE_DRIVE_COUNT = "MasterStrDrvCount";
export const MASTER_TENANT_DRIVE = "MasterTenantStrDrvtype";
export const MASTER_TENANT_DRIVE_COUNT = "MasterTenantStrDrvCount";
export const MASTER_OSDRIVE = "MasterOSDrive";
export const MIXED_STORAGE_SERVER_CHANGE_WARNING = "All Mixed Storage Configurations have to be deleted to change server selection.";
export const TENANT = "Tenant";
export const NODE = "Node";
export const NVME_ =  "NVME";
export const HPECP_SIZER = "EzmeralCPSizer";
export const HPE_E_CP = "HPE Ezmeral RE";
export const HPE_E_CPDESC = "HPE Ezmeral Runtime Enterprise";
export const RE = "Runtime Enterprise"
export const RE_SHORT = "RE";
export const E910 = "e910";
export const EL4000 = 'EL4000';
export const HPECP_SUPPORTED_SERVERS_LIST = ["ProLiant XL170r Gen10", "ProLiant XL190r Gen10", "ProLiant XL270d Gen10", "HPE Apollo 4200 Gen10 Server", "HPE Apollo 4500 Gen10 System", "Synergy 480 Gen10 Server", "ProLiant DL360 Gen10", "ProLiant DL380 Gen10"];
export const HPECP_WARNING_MESSAGE = 'Please click on Calculate Sizer Recommendation button to perform Finish.';
export const CONFIGURE_IN_ALL_SERVICES_MESSAGE = 'Please selet the workload and click on Calculate Sizer Recommendation button in all selected services to perform Finish.'
export const HPECP_CONTAINER_PAGE = 'HPEEzmeralRuntimeEnterprise';
export const NAV_MESSAGE = 'Click here to navigate.';
export const WARNING_TEXT = "Warning";
export const HPE_APOLLO_4200_GEN10 = "HPE Apollo 4200 Gen10 Server";
export const HPE_APOLLO_4200_GEN10_PLUS = "HPE Apollo 4200 Gen10 Server Plus";
export const HPE_APOLLO_4500_GEN10 = "HPE Apollo 4500 Gen10 System";
export const SYN_480_GEN10 = "Synergy 480 Gen10 Server";
export const SYN_480_GEN10_PLUS = "Synergy 480 Gen10 Plus Server";
export const PROLIANT_DL360_GEN10 = "ProLiant DL360 Gen10";
export const PROLIANT_DL380_GEN10 = "ProLiant DL380 Gen10";
export const PROLIANT_DL360_GEN10_PLUS = "ProLiant DL360 Gen10 Plus";
export const PROLIANT_DL365_GEN10_PLUS = "ProLiant DL365 Gen10 Plus";
export const PROLIANT_DL325_GEN10_PLUS_V2 = "ProLiant DL325 Gen10 Plus v2";
export const PROLIANT_DL380_GEN10_PLUS = "ProLiant DL380 Gen10 Plus";
export const PROLIANT_DL385_GEN10_PLUS = "ProLiant DL385 Gen10 Plus";
export const PROLIANT_DL325_GEN10_PLUS = "ProLiant DL325 Gen10 Plus";
export const PROLIANT_XL290N_GEN10_PLUS = "ProLiant XL290n Gen10 Plus";
export const GATEWAY_NODE = "Gateway Node";
export const MASTER_NODE = "Master Node";
export const PERSISTENT_ = "Persistent";
export const TRUE_ = "True";
export const FALSE_ = "False";
export const tRUE_ = "true";
export const fALSE_ = "false";
export const NONE_ = "None";
export const INCHES_ = '2.5IN';
export const INCHES_THREE = '3.5IN';
export const NINE_X_FIVE = "9x5 1y";
export const MOONSHOT_510 = 'm510';
export const MOONSHOT_750 = 'm750';
export const SFF_DESCRIPTIONS = ['SFF', '2.5IN'];
export const ERROR_TEXT = "Error";
export const DRIVE_CANNOTBE_MIXED = "The selected drive type cannot be mixed with existing drives.";
export const MAXDRIVEQTY_EXCEEDED = ["Maximum Drive Quantity (", ") is exceeded for the selected drive type."];
export const HORTONWORK_ENT = "HortonWork Enterprise";
export const HORTONWORK_ENT_PLUS = "HortonWork Enterprise Plus";
export const HORTONWORKS_DATAFLOW = "Hortonworks DataFlow";
export const CLOUDERA_ESSENTIALS = "Cloudera Essentials";
export const CLOUDERA_ENT_DATAHUB = "Cloudera Enterprise Data Hub";
export const CLOUDERA_DATA_ENGINEERING = "Cloudera Data Engineering";
export const CLOUDERA_OP_DATABASE = "Cloudera Operational Database";
export const CLOUDERA_ANALYTICAL_DB = "Cloudera Analytical Database";
export const HPE_EZMERAL_MLOPS = "HPE Ezmeral ML Ops";
export const KUBERNETES_CM = "Kubernetes CM";
export const HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR = "HPE Ezmeral RE External Kubernetes Cluster Manager";
export const LFF_ = 'LFF';
export const SATA_ = 'SATA';
export const HDD_ = 'HDD';
export const SAS_ = 'SAS';
export const NVMe_ = 'NVMe';
export const M_2 = 'M.2';
export const TRAINING_ = "Training-";
export const INFERENCE_ = "Inference";
export const SPARK_JUPYTER_CONTAINER_GPU_MEDIUM = "Spark Jupyter-Container GPU Medium";
export const SPARK_JUPYTER_CONTAINER_GPU_LARGE = "Spark Jupyter-Container GPU Large";
export const TENSORFLOW_JUPYPETER_CONTAINER_GPU_MEDIUM = "Tensorflow Jupyter-Container GPU Medium";
export const TENSORFLOW_JUPYPETER_CONTAINER_GPU_LARGE = "Tensorflow Jupyter-Container GPU Large";
export const INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_MEDIUM = "Inference-Tensorflow ModelServer-Container GPU Medium";
export const INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_LARGE = "Inference-Tensorflow ModelServer-Container GPU Large";
export const DATA_APPS = "Data Apps";
export const DATA_APPS_wMLOPs = "Data Apps w/ML Ops";
export const HARDWARELICENSE_PARAGRAPH_CLASSNAME = "HardwareLicensesParagraph";
export const INFOICON_COLORINDEX = "accent-3";
export const INCLUDE_HA_TOOLTIP = 'Checking the High Availability check box will add two additional controller servers. One for a Shadow Controller and one Arbiter. In addition the minimum number of gateway servers will be set to two.';
export const SEPARATE_STORAGE_HOSTS_TOOLTIP = "Data Fabric or Persistent Storage is to be configured on separate storage hosts.";
export const PROLIANT_XL225N_GEN10_PLUS =  "ProLiant XL225n Gen10 Plus";
export const PROLIANT_XL220N_GEN10_PLUS =  "ProLiant XL220n Gen10 Plus";
export const DLC = "DLC";   
export const AC = "AC";
export const NUMERIC_ONE = "1";
export const NUMERIC_TWO = "2";
export const yES_ = "yes";
export const nONE_ = "none";
export const nO_ = "no";
export const EPIC_ = "EPIC";
export const KUBERNETES_ = "Kubernetes";
export const WHITE_COLOR = "white";
export const BLACK_COLOR = "black";
export const BLOCK_ = "block";
export const TAB_BACKGROUND = '#425563 80%'
export const BOTH_ = "Both";
export const VMWARE = "VMWare";
export const VMWARE_VCENTER = "VMWare vCenter";
export const VMWARE_VSPHERE = "VMWare vSphere";
export const VMWARE_VREALIZE = "VMWare vRealize";
export const VMWARE_VSAN = "VMWare vSAN";
export const MLOPS = "MLOps";
export const CAAS_ = "CaaS";
export const GATEWAY_HOST = "Gateway Host";
export const CONTROLLER_HOST = "Controller Host";
export const MASTER_HOST = "Master Host";
export const EPA_GROWTH_HEADINGS = ['Services', 'Growth Y/Y', '%', 'Total # of Nodes Yr 1', 'Total # of Nodes Yr 2', 'Total # of Nodes Yr 3'];
export const EZMERAL_GROWTH_HEADINGS = ['Services', 'Growth %', 'Total # of Host Yr 1', 'Total # of Host Yr 2', 'Total # of Host Yr 3', 'Total # of Host Yr 4'];
export const MLOPS_CAAS = ["MLOps", "CaaS"];
export const GENERAL_PURPOSE = "Runtime Enterprise";
export const EZMERAL_ = "Ezmeral";
export const TOTALS_TEXT = " Totals :";
export const NODE_STORAGE_DRIVE = "NodeStorageDrive";
export const NODE_STORAGE_DRIVE_QTY = "NodeStorageDriveQty";
export const EPHEMERAL_STORAGE_DTIVE_QUANTITY = "Ephemeral Storage Drive Quantity";
export const EPHEMERAL_STORAGE_DRIVE = "Ephemeral Storage Drive";
export const CONFIGURATION_MARGIN = '8%';
export const ZERO_PERCENT = '0%';
export const HYPHEN_ = "-";
export const SIZE_ATTRIBUTE = "@size";
export const LST_HDFS_DRIVES = 'lstHDFSDrives';
export const DDRIVE_SIZE = 'DDriveSize';
export const STR_DRIVE = 'StrDrive';
export const I_QTY = 'IQty';
export const CONFIGURATION_OPTIONS = ["Cost", "Density", "Performance", "Power"];
export const configurationWidth = '13%';
export const templateWidth = '18%';
export const clustersWidth = '10%';
export const nodesPerClusterWidth = '12%';
export const coresWidth = '9%';
export const memoryWidth = '9%';
export const EphemeralStorageWidth = '10%';
export const persistentStorageWidth = '10%';
export const GPUsWidth = '9%';
export const TRAINING = "Training";
export const IMAGE_PROCESSING = "Image Processing";
export const MLOPS_TEMPLATES = "MLOps Templates";
export const MLOPS_IMAGE_PROCESSING = "MLOps Image Processing";
export const DATA_FABRIC = "Data Fabric";
export const PROLIANT_XL170r = "ProLiant XL170r Gen10";
export const HP_MOONSHOT_SYSTEM = "HP Moonshot System";
export const GPU_RESULT = "GPU_Result";
export const NONGPU_RESULT = "NonGPU_Result";
export const TEXT_ATTRIBUTE = "#text";
export const ATTRIBUTE_TYPE = "@Type";
export const ATTRIBUTE_ISSELECTED = "@IsSelected";
export const ATTRIBUTE_DESCRIPTION = "@Description";
export const QTY_ONE = "1";
export const QTY_TWO = "2";
export const CAAS_MEMORY = "384 GB";
export const MANAGEMENT_HOSTS = "ManagementHosts";
export const DISK_ = "Disk";
export const PROCESSOR_ = "Processor";
export const MEMORY_ = "Memory";
export const TB_ = 'TB';
export const GB_ = 'GB';
export const EDGELINE_ = "Edgeline";
export const POWER_ = "Power";
export const DATA_LAKE = "Data Lake";
export const HDFS_ = "HDFS";
export const HDFS_EC = "HDFS and HDFS-EC";
export const RAW_ = "Raw";
export const ATTRIBUTE_OSDRIVE = "OSDrive";
export const ATTRIBUTE_PERSISTENTDRIVEQTY = "PersistentDriveQty";
export const DATALAKE_COMPRESSION_MINVLAUE = "0.00";
export const DATALAKE_COMPRESSION_MAXVLAUE = "1.00";
export const HPE_EZMERAL_DATAFABRIC = "HPE Ezmeral Data Fabric";
export const HPE_EZMERAL_DF_XD = "HPE Ezmeral Data Fabric XD";
export const HPE_EZMERAL_DF_FILE_STORE = "HPE Ezmeral Data Fabric File Store";
export const HPE_EZMERAL_DF_ANALYTICS = "HPE Ezmeral Data Fabric Analytics";
export const HPE_EZMERAL_DF_SPARK = "HPE Ezmeral Data Fabric Spark";
export const HPE_EZMERAL_DF_STREAMS = "HPE Ezmeral Data Fabric Streams";
export const HPE_EZMERAL_DF_DATABASE = "HPE Ezmeral Data Fabric Database";
export const HPE_EZMERAL_DF_BUNDLE = "HPE Ezmeral Data Fabric Bundle";
export const DATAFABRIC_XD = "DataFabric XD";
export const DATAFABRIC_ANALYTICS = "DataFabric Analytics";
export const DATAFABRIC_SPARK = "DataFabric Spark";
export const DATAFABRIC_STREAMS = "DataFabric Streams";
export const DATAFABRIC_DATABASE = "DataFabric Database";
export const DATAFABRIC_BUNDLE = "DataFabric Bundle";
export const DATAFABRIC_SERVICES = "HPE Ezmeral Data Fabric Services";
export const DATALAKE_REPLICATION_MINVALUE = "1.00";
export const DATALAKE_REPLICATION_MAXVALUE = "5.00";
export const SERVICES_ = "Services";
export const HPE_CONTAINER_PLATFORM = "HPE Container Platform";
export const BLUEDATA_AI = "BlueDataAI";
export const DATALAKE_MIN_NODES = "4";
export const INFERENCE_SERVERS = [PROLIANT_DL360_GEN10, PROLIANT_DL380_GEN10];
export const EZMERAL_CP_OPTION = "EzmeralREOption";
export const SERVERCHANGE_WARNINGTEXT = "The selected server does not support the existing drive configuration, please delete the mixed drive configuration to change the server."
export const IOT_ = "IoT";
export const MINIFI = "MiNifi";
export const FUNCTIONNAME_ = "functionName";
export const SERVICENAME_ = "serviceName";
export const DATADISKS_ = "DataDisks";
export const ATTRIBUTE_dISK = "@disk";
export const ATTRIBUTE_qTY = "@qty";
export const NONE_RADBTN_ID = "choice1-4";
export const CUSTOM_TEMPLATE = "Custom";
export const CUSTOM_WGPUS = "Custom w/GPUs";
export const ATTRIBUTE_VCLUSTERS = "@vClusters";
export const ATTRIBUTE_NODESPERCLUSTER = "@vNodesPerCluster";
export const ATTRIBUTE_VCPUPERNODE = "@vCPUPerNode";
export const ATTRIBUTE_VMEMORYPERNODE = "@vMemoryPerNode";
export const ATTRIBUTE_VSTORAGEPERNODE = "@StoragePervNode";
export const OVERHEAD_ = "Overhead";
export const REPLICATION_ = "Replication";
export const STORAGE_TO_COMPUTE_RATIO = "Storage to Compute Ratio";
export const PERSISTENT_STORAGE_DEFAULTVALUE = "0";
export const CUSTOMTEMPLATE_DEFAULTVALUE = "1";
export const PROLIANT_XL675D_GEN10_PLUS = "ProLiant XL675d Gen10 Plus";
export const PROLIANT_XL645D_GEN10_PLUS = "ProLiant XL645d Gen10 Plus";
export const A100_SXM4_40GB = "A100-SXM4-40GB";
export const PROLIANT_E910T_2U_SERVER = "HPE ProLiant e910t 2U CTO Blade Server";
export const PROLIANT_E910_2U_SERVER = "HPE ProLiant e910 2U CTO Blade Server";
export const T4_TESLA_GPU = "Tesla-PCIE-16GB";
export const HPE_Ezmeral_CP_Option = "HPE RE Licenses and Services are applicable for HPE servers";
export const DiskCapacity = "Total Storage capacity (TB) required for the cluster.";
export const Overhead = "It is the extra space needed to store the raw data, like temp files, metadata, logs etc";
export const Storage_Workload = "StorageWorkload field allows you to fine tune sizing vs Equivalent 2P nodes.20% is the average value. If you know your workload is more Storage oriented, you can increase this percentage in order to obtain more accurate sizing";
export const CapacityType = "Select “Raw” if you want to input Raw Storage, Select “Usable” if you want to input usable Storage";
export const Compression = "It reduces the space needed to store files, and it speeds up data transfer across the network to or from disk.";
export const Replication = "Number of replicas to store.";
export const Select_Green_Lake_Flex_Capacity = "Add HPE Green Lake Flex capacity";
export const Replication_to_a_second_site = "Replication to multiple sites";
export const calculated_ARC_level = "For Erasure Coding scheme.";
export const Add_servers_to_this_deployment = 'Select No if building a configuration for a temporary POC environment or eternally small configuration';
export const BOM_and_SKU_information = "Sizing using selected hardware configuration and server count.";
export const SelectWorkloadTemp = "Select the workload templates that best fits your workload. You can modify the inputs to fit the requirements. Each template configures core/memory/storage requirements for each container. Also number of containers for each cluster is configured.";
export const EzemeralServicesToolTips = {
"Runtime Enterprise" : "Small/Medium/Large configurations with Container and Physical requirements are available. Also Utility with  Medium/Large configuration are available with this option. Physical configuration with 22 core/150GB mem/1.5TB ephemeral storage can be selected. Medium and Large physical configurations add 20TB and 40TB persistent storage and 3/10/20 nodes are configured with Small/Medium/Large templates. Containers  with 4 core/16GB mem/100GB ephemeral storage configurations. Medium and Large container configurations have larger memory and storage. All parameters are configurable.",
"Data Fabric" : "Small/Medium/Large Storage configurations with Container and Physical requirements are available. Also Hadoop/HDF/MapR/Spark containers with HA and Small/Medium/Large configuration are available in this option. Physical configuration with 22 core/150GB mem/1.5TB ephemeral storage can be selected. Medium and Large physical configuration add 20TB and 40TB persistent storage and 3/10/20 nodes are configured with Small/Medium/Large templates. Containers  with 4 core/16GB mem/100GB ephemeral storage configurations. Medium and Large container configurations have larger memory and storage. All parameters are configurable.",
"Unified Analytics" : "Small/Medium/Large Analytics configurations with Container and Physical requirements are available. Also Kafka/Elastic Search/MySQL/Spark containers with Medium/Large configuration are available in this option. Physical configuration with 22 core/150GB mem/1.5TB ephemeral storage can be selected. Medium and Large physical configuration add 20TB and 40TB persistent storage and 3/10/20 nodes are configured with Small/Medium/Large templates. Containers  with 4 core/16GB mem/100GB ephemeral storage configurations. Medium and Large container configurations have larger memory and storage. All parameters are configurable.",
"MLOps" : "Inference and Training (Small/Medium/Large) configurations with Container and Physical GPU requirements are available in this option. Physical configuration with 22 core/150GB mem/1.5TB storage can be selected. Can be used to build a bare metal server. Medium and Large physical configuration add 20TB and 40TB persistent storage and 3/10/20 nodes are configured with Small/Medium/Large templates. Containers  with 4 core/16GB mem/100GB ephemeral storage configurations. Medium and Large container configurations have larger memory and storage. All parameters are configurable.",
"CaaS" : "Small/Medium/Large configurations with Container and Physical requirements are available. Physical configuration with 22 core/150GB mem/1.5TB storage can be selected and can be used to build a bare metal server with those parameters. Small, Medium and Large physical configuration add 10TB, 20TB and 40TB persistent storage. Physical host with 12 nodes are configured with Small/Medium/Large templates with different memory and storage requirements. Container configuration with 4 core/16GB mem/100GB storage. Medium and Large container configurations have large memory and storage. All parameters are editable and number of containers is prepopulated."
}

export const DEFAULT_GROWTH_OBJECT = {
       Service : [
           {
               "@GrowthRate": "0",
               "@GrowthType": "Nodes",
               "@Name": "Storage",
               "@Nodes1Y": "37",
               "@Nodes2Y": "-",
               "@Nodes3Y": "-",
               "@Service": "Data Lake"  
           },
           {
               "@Name": "Master Node", 
               "@Service": "", 
               "@GrowthType": "Nodes", 
               "@GrowthRate": "0", 
               "@Nodes1Y": "3",
               "@Nodes2Y": "-",
               "@Nodes3Y": "-",
               "@Service": ""
           }
       ]
   }
   export const VMWARE_VCENTER_3YRS = "VMWare vCenter 3 Years";
   export const VMWARE_VSPHERE_3YRS = "VMWare vSphere 3 Years";
   export const RI = "RI";
   export const IMAGE_PER_SEC = "@ImagesPerSec";



// WEBPACK FOOTER //
// ./src/SizerUI/Redux/action_types/EPAConstants.js